/** The backend rejects a longer call note with a validation error (400). */
export const TELEPHONY_CALL_NOTE_MAX_LENGTH = 2000;
